import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { featureHelpers } from './feature-helpers';

export class RequireFeatureComponent extends Component {

  render() {
    const { requiredFeatures, children, hideDisplay } = this.props;

    var featuresEnabled = featureHelpers.featuresEnabled(requiredFeatures);

    if(featuresEnabled) {
      return (
        <div>
          {children}
        </div>
      );
    }
    else {
      return hideDisplay;
    }
  }
}

RequireFeatureComponent.defaultProps = {
  hideDisplay: null
};

RequireFeatureComponent.propTypes = {
  features : PropTypes.object,
  featureActions : PropTypes.object,
  requiredFeatures : PropTypes.array.isRequired,
  hideDisplay: PropTypes.any,
};

export default RequireFeatureComponent;
